import React, { FC, ReactNode } from 'react';

import styled from 'styled-components';

import { Box } from '@adsk/alloy-react-box';

import ProductLink from './ProductLink';
import ProductLinksMenu from './ProductLinksMenu';
import { ProductLinkType, BREAKPOINTS } from '../consts';

const ProductLinksContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
});

const ProductLinkCollapsibleContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
  '&': {
    [BREAKPOINTS.SMALL]: {
      a: { display: 'none' },
    },
  },
});

const ProductLinksMenuContainer = styled.div({
  display: 'none',
  [BREAKPOINTS.SMALL]: {
    display: 'block',
  },
});

type ProductLinksSectionProps = {
  helperText?: ReactNode;
  links: ProductLinkType[];
  collapseOnSmallScreens?: boolean;
};

const ProductLinksSection: FC<ProductLinksSectionProps> = ({
  helperText,
  links,
  collapseOnSmallScreens = false,
}) => {
  if (!links.length) {
    return null;
  }

  const LinksContainer = collapseOnSmallScreens
    ? ProductLinkCollapsibleContainer
    : ProductLinksContainer;

  return (
    <>
      {helperText && (
        <Box typography="labelSmall" color="charcoal700" mr={16}>
          {helperText}
        </Box>
      )}
      <LinksContainer>
        {links.map(({ variant, url, label, icon }) => (
          <ProductLink
            key={label}
            variant={variant}
            url={url}
            label={label}
            icon={icon}
          />
        ))}
      </LinksContainer>
      {collapseOnSmallScreens ? (
        <ProductLinksMenuContainer>
          <ProductLinksMenu links={links} />
        </ProductLinksMenuContainer>
      ) : null}
    </>
  );
};

export default ProductLinksSection;
